
<template>
    <div class="left" style="width: 100%; height: 100%">
        <i
            class="switch"
            @click="noSide = !noSide"
            style="font-size: 50px; background: #fff"
            :class="[
                noSide
                    ? 'el-icon-caret-left ileft'
                    : 'el-icon-caret-right iright',
            ]"
        ></i>

        <div
            class="menu"
            :class="{ noSide: noSide }"
            style="width: 100%; height: 100%"
        >
            <el-card class="box-card" style="width: 100%; height: 100%">
                <div style="text-align: left">
                    <el-row>
                        <el-input
                            placeholder="请输入聚落名称"
                            class="input-with-select"
                            v-model="juLuoKeyWord"
                            clearable
                        >
                            <el-button
                                slot="append"
                                icon="el-icon-search"
                                @click="searchJuLuo"
                            ></el-button>
                        </el-input>
                    </el-row>
                    <el-row style="margin-top: 0.5rem">
                        <span
                            v-if="searchTipFlag && juLuoKeyWord != ''"
                            style="color: red"
                            >你搜索的“{{ juLuoKeyWord }}”暂无结果。</span
                        >
                    </el-row>
                    <el-row>
                        <div style="height: 13rem; margin-top: 1rem">
                            <div class="side-title">府级政区：</div>
                            <div class="side-box">
                                <el-button
                                    :type="
                                        item == highLightFuItem
                                            ? 'primary'
                                            : 'text'
                                    "
                                    class="side-item"
                                    v-for="(item, index) in fuData"
                                    v-bind:key="index"
                                    style="text-align: center; padding: 10px"
                                    @click="changeCountry(item)"
                                >
                                    {{ item }}
                                </el-button>
                            </div>
                        </div>
                    </el-row>
                    <el-row>
                        <div style="height: 6rem">
                            <div class="side-title">县级政区：</div>
                            <div class="side-box">
                                <el-button
                                    :type="
                                        item == highLightCounterItem
                                            ? 'primary'
                                            : 'text'
                                    "
                                    class="side-item"
                                    v-for="(item, index) in countryData"
                                    v-bind:key="index"
                                    style="text-align: center; padding: 10px"
                                    @click="changeCounty(item)"
                                >
                                    {{ item }}
                                </el-button>
                            </div>
                        </div>
                    </el-row>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            //data: [],
            // 厅县数据
            data: [],
            // 府数据 展示
            fuData: [],
            // 当前选择的府数据
            highLightFuItem: '',
            // 县数据 展示
            countryData: [],
            highLightCounterItem: '',

            noSide: true,

            // 当前搜索聚落关键词
            juLuoKeyWord: '',
            searchTipFlag: false,
        }
    },
    computed: {},
    mounted() {
        this.getCountry()
    },
    watch: {
        juLuoKeyWord: {
            deep: true,
            handler(newVal, oldVal) {
                this.debounce(this.searchJuLuo, 500)
            },
        },
    },
    methods: {
        //防抖
        debounce(fn, wait) {
            if (this.searchTimer !== null) {
                clearTimeout(this.searchTimer)
            }
            this.searchTimer = setTimeout(fn, wait)
        },
        // 获取厅县数据
        getCountry() {
            let temp = {}
            axios({
                url: $webConfig.V3.owsBaseURL,
                method: 'get',
                params: {
                    service: 'WFS',
                    version: '1.0.0',
                    request: 'GetFeature',
                    typeName: 'lwdgis:gs_county_region_1911',
                    outputFormat: 'application/json',
                },
            }).then((res) => {
                res.data.features.forEach((feature) => {
                    let item = feature.properties
                    let key = item.二级政
                    if (!(key in temp)) {
                        temp[key] = []
                    }
                    temp[key].push(item.CHNAME)
                })
                this.data = temp

                let fuDataTemp = []
                for (let i in temp) {
                    fuDataTemp.push(i)
                }
                // fuData 字数少的放前面
                this.fuData = fuDataTemp.sort(function (a, b) {
                    return a.length - b.length
                })
            })
        },

        // 点击不同的府
        changeCountry(value) {
            this.highLightFuItem = value
            this.countryData = this.data[value]
        },
        // 点击县
        changeCounty(value) {
            this.highLightCounterItem = value
            this.$emit('zoomToCounty', value)
        },

        // 右侧 聚落搜索
        searchJuLuo() {
            let flag = true
            this.$parent.displayJuLuoLayer
                .getSource()
                .getFeatures()
                .forEach((feature) => {
                    if (feature.getProperties().name == this.juLuoKeyWord) {
                        this.$emit('popInfo', feature.getProperties())
                        flag = false
                    }
                })
            if (flag) {
                this.searchTipFlag = true
            } else {
                this.searchTipFlag = false
            }
        },
    },
}
</script>

<style scoped >
.left {
    background: #fff;
    position: relative;
}
.left .switch {
    display: inline-block;
    position: absolute;
}
.ileft {
    right: 1px;
}
.iright {
    left: -50px;
}
.menu {
    transition: all 300ms;
}
.menu.noSide {
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/V3/Main/Home/comRightDraw.vue